// extracted by mini-css-extract-plugin
export var paginationContainer = "_81-0";